import React, { useState, useEffect, useContext, useRef } from 'react'
import { useParams } from 'react-router-dom'
import './workspace.scss'
import SideBar from './sidebar/SideBar'
import PlusIcon from './PlusIcon'
import SnippetContainer from './snippets/SnippetContainer'
import { WorkspaceContext } from './WorkspaceContext'
import NewSnipPop from './snippets/NewSnipPop'
import JoinRoomIcon from '../../shared/components/svgIcons/JoinRoomIcon'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import NewFolderPopup from './files/NewFolderPopup'
import AddNewPopup from './files/AddNewPopup'
import FailedToDownload from './FailedToDownload'
import RoomSettingsInfoPopup from './settings/RoomSettingsInfoPopup'
import QrCodePopup from './QrCodePopup'
import ExpandIcon from '../../shared/components/svgIcons/ExpandIcon'
import FileList from './files/FileList'
import { DriveViewProvider } from './DriveViewContext'
import { useWorkspaceDocumentTitle } from './hooks/useWorkspaceDocumentTitle'
import { useWorkspaceThemePrompt } from './hooks/useWorkspaceThemePrompt'
import { useIdleDisconnect } from './hooks/useIdleDisconnect'
import { UploadEngineProvider } from './files/UploadEngineContext'
import { useWorkspaceFileDropZone } from './files/useWorkspaceFileDropZone'






const WorkspacePage = () => {

    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");
    const { ctheme, prompt, setcTheme, setPrompt, limitPopup, limitMessage, globalNewFilePopup, globalNewSnipPopup, roomDetails, memberDetails, globalNewFolderPopup, addNewPopup, setAddNewPopup, downloadFileErrorPopup, roomSettingsInfoPopup, uiMode, qrPopup, setQrPopup } = ctx;
    const limitPopupTitle = /limit|maximum|storage/i.test(limitMessage ?? '') ? 'Limit Reached' : 'Something went wrong';








    const [nav, openNav] = useState(false);



    const newPopupClick = () => {
        setAddNewPopup(true);
    }

    useEffect(() => {
        if (!nav) {
            // ensure cleanup if nav is false
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        // --- lock scroll (keeps current scroll position) ---
        const scrollY = window.scrollY;

        // add blur class to <html> (we'll define CSS below)
        document.documentElement.classList.add("nav-blur");

        // lock body in place
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            // --- restore ---
            document.documentElement.classList.remove("nav-blur");

            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);

    const { roomId } = useParams();

    const { setColorClick } = useWorkspaceThemePrompt(roomId, setcTheme, setPrompt);

    const workspaceRef = useRef<HTMLDivElement | null>(null);

    useWorkspaceDocumentTitle(roomDetails?.roomName, roomId);

    useIdleDisconnect(roomId);

    return (
        <div ref={workspaceRef} id='work-space' className={`relative ${ctheme === 'dark' ? 'dark' : 'light'}`}>
            <DriveViewProvider>
            <UploadEngineProvider>
            <WorkspaceDropZone workspaceRef={workspaceRef}>

            {addNewPopup &&

                <AddNewPopup />

            }

            {roomSettingsInfoPopup &&
                <RoomSettingsInfoPopup />
            }

            {qrPopup &&
                <QrCodePopup />
            }


            {limitPopup && limitMessage ? (
                <div className='limit-popup'>
                    <span>{limitPopupTitle}</span>
                    <p>{limitMessage}</p>
                </div>
            ) : (
                <> </>
            )

            }

            {prompt &&
                <div className='theme-prompt'>
                    <h2>How do you prefer your workspace?</h2>

                    <div className='tpbs'>
                        <div className='theme-prompt-mode-btn'
                            onClick={() => setColorClick("dark")}
                        >
                            <div className='tpci tcpi-dark' />
                            <span>Dark</span>
                        </div>

                        <div className='theme-prompt-mode-btn'
                            onClick={() => setColorClick("light")}

                        >
                            <div className='tpci tcpi-light' />
                            <span>light</span>
                        </div>
                    </div>
                </div>
            }

            <SideBar />
            <div id='editor-space'>


                {globalNewFolderPopup &&
                    <NewFolderPopup />
                }


                {globalNewSnipPopup &&
                    <NewSnipPop />
                }

                {downloadFileErrorPopup &&
                    <FailedToDownload />
                }

                <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                    <div className='standard-xi-cont'

                        onClick={() => openNav(false)}
                    >

                        <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                            <g id="Layer_3" data-name="Layer 3">
                                <path
                                    className="cls-1"
                                    d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                    transform="translate(-124.17 -181.62)"
                                />
                            </g>
                        </svg>

                    </div>

                    <SBNav />

                </div>


                <div id="snippet-editor-and-controls">
                    <div className='top-bar'>

                        <div className='quick-flex logo-top mobile-topbar-brand'>
                            {ctheme === 'dark' ? (
                                <img draggable={false} className='no-select' src={`${process.env.PUBLIC_URL}/images/flashroom-logo-light.png`} alt='flashroom logo' />
                            ) : (
                                <img draggable={false} className='no-select' src={`${process.env.PUBLIC_URL}/images/flashroom-logo-dark.png`} alt='flashroom logo' />
                            )}

                            <h1 style={{ lineHeight: '1' }} className='pop no-select'>Flash<span>Room</span></h1>
                        </div>


                        {memberDetails?.canCreate ? (
                            <div className='center addspace clickable desktop-add-slot'>
                                <button onClick={newPopupClick} className='new-btn'>
                                    Add
                                    <PlusIcon />
                                </button>


                            </div>
                        ) : (
                            <div className='noEditBadge desktop-add-slot'>
                                <h4>View Only</h4>
                            </div>
                        )

                        }


                        <div className='desktop-join-slot'>
                            {
                                roomDetails ? (
                                    <button
                                        type='button'
                                        className='quick-flex top-bar-join primary-t-bg join-code-trigger'
                                        onClick={() => setQrPopup(true)}
                                        title='Show room join details'
                                    >
                                        <JoinRoomIcon />

                                        <div className='sjm-c'>
                                            {roomDetails?.entranceCode.split("").map((l, index) => (
                                                <React.Fragment key={index}>
                                                    <div className='sjm-l'>
                                                        <p>{l}</p>
                                                    </div>

                                                    {(index === 2 || index === 4) && <span className="sjm-dash">-</span>}
                                                </React.Fragment>
                                            ))}
                                        </div>

                                        <ExpandIcon />
                                    </button>
                                ) : (
                                    <h3 className='loading'>Loading...</h3>
                                )
                            }
                        </div>


                        <div className='primary-t-bg' id='et-ws'>
                            <img draggable={false} src={`${process.env.PUBLIC_URL}/images/${ctheme === 'light' ? 'room-icon' : 'room-icon-white'}.png`} width="20px" />
                            <h2>{roomDetails?.roomName}</h2>
                        </div>

                        <div className='primary-t-bg' id="workspace-hamburger-menu"
                            onClick={() => openNav(true)}>
                            <div />
                            <div />
                            <div />
                        </div>

                    </div>

                    {
                        uiMode === 'editor' ? (
                            <div className={`fade-in ${!globalNewFilePopup ? 'workspace-regular' : 'workspace-hidden'}`}>
                                <SnippetContainer />
                            </div>
                        ) : (
                            <div className='workspace-regular file-list-workspace fade-in'>
                                <FileList />
                            </div>
                        )
                    }
                </div>
            </div>

            </WorkspaceDropZone>
            </UploadEngineProvider>
            </DriveViewProvider>
        </div>
    )
}

type WorkspaceDropZoneProps = {
    workspaceRef: React.RefObject<HTMLDivElement | null>;
    children: React.ReactNode;
};

// Wires up room-wide OS file drag/drop (permission check, target-folder
// resolution, upload) and a visual "this is a drop target" affordance while
// it's happening. Placed inside DriveViewProvider/UploadEngineProvider since
// useWorkspaceFileDropZone needs both; renders no DOM of its own (a wrapping
// div here would sit between #work-space and its flex children — SideBar and
// #editor-space — and break #work-space's flex layout) — instead the drag-
// over class is toggled directly on the real #work-space node via the ref.
const WorkspaceDropZone = ({ workspaceRef, children }: WorkspaceDropZoneProps) => {
    const { isDraggingFiles } = useWorkspaceFileDropZone(workspaceRef);

    useEffect(() => {
        const el = workspaceRef.current;
        if (!el) return;
        el.classList.toggle('workspace-drop-zone-active', isDraggingFiles);
    }, [isDraggingFiles, workspaceRef]);

    return <>{children}</>;
};

export default WorkspacePage
